import Nullstack from 'nullstack';
export default function IconPolaroid({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-polaroid",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "16",
    x2: "20",
    y2: "16"
  }), "   ", Nullstack.element("path", {
    d: "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "7",
    x2: "14.01",
    y2: "7"
  }), " ");
}